module.exports = __webpack_public_path__ + "img/about_banner1.b8585966.jpg";